/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export const COMBINED_GUIDE_PAGE_NAME = 'Guide';
export const COMBINED_GUIDE_PAGE_ID = 'COMBINED_GUIDE';
